import React from 'react';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { showModal } from 'actions';

import {
  getArchivedFSObjects,
  restoreFSObject,
  downloadFSDoc,
  searchArchivedFSObjects,
  clearArchivedFSObjectsSearchResults,
  setArchivedFSObjectSorting
} from 'actions/Event';

import FSObjectArchiveList from 'components/event/FileSystem/FSObjectArchiveList';
import { onCancelSearch, onSearchTermChange } from './EventDashFolders';
import styled from 'styled-components';
import FileSystemSearchInput from '../components/event/FileSystem/FileSystemSearchInput';
import ViewRelativePaths from 'constants/CuesheetViews';

import {
  isDirectory,
  isDocFSObject,
  getFSRefObjectId
} from 'components/event/FileSystem/fsObjectUtils';

const OptionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 0 !important;

  @media only screen and (max-width: 556px) {
    position: sticky;
    transform: translateX(110px);
  }
`;

class Unconnected extends React.Component {
  constructor(props) {
    super(props);

    const { history, downloadDoc, teamId, eventId, user } = this.props;

    const userViewPreference =
      user.preferences && user.preferences.cuesheetView;

    const viewPath = userViewPreference
      ? ViewRelativePaths[userViewPreference]
      : ViewRelativePaths.Compact;

    this._onItemClick = itemClickHandler.bind(
      null,
      history,
      downloadDoc,
      teamId,
      eventId,
      viewPath
    );

    this._onDeleteClick = this._onDeleteClick.bind(this);
    this._setSearchTerm = this._setSearchTerm.bind(this);

    this.state = {
      searchTerm: ''
    };
  }

  componentDidMount() {
    const { eventId, getArchived } = this.props;
    getArchived(eventId);
  }

  render() {
    const {
      items,
      sorting,
      onSortChange,
      eventId,
      restore,
      isLoading,
      teamId,
      searchResults,
      searchArchivedFSObjects,
      clearArchivedFSObjectsSearchResults
    } = this.props;

    const { searchTerm } = this.state;

    const optionsNode = (
      <OptionsWrapper>
        <FileSystemSearchInput
          onChange={onSearchTermChange.bind(
            null,
            teamId,
            eventId,
            this._setSearchTerm,
            searchArchivedFSObjects,
            clearArchivedFSObjectsSearchResults
          )}
          onResultClick={this._onItemClick}
          onCancel={onCancelSearch.bind(
            null,
            this._setSearchTerm,
            clearArchivedFSObjectsSearchResults
          )}
          value={searchTerm}
          results={searchResults}
        />
      </OptionsWrapper>
    );

    return (
      <FSObjectArchiveList
        items={items}
        eventDashOptionsNode={optionsNode}
        onSortChange={onSortChange}
        sorting={sorting}
        onDeleteClick={this._onDeleteClick}
        onRestoreClick={restore}
        isLoading={isLoading}
        onItemClick={this._onItemClick}
      />
    );
  }

  _onDeleteClick(fsObject) {
    const { showModal } = this.props;
    showModal('DELETE_FS_OBJECT', fsObject);
  }

  _setSearchTerm(term) {
    this.setState({ searchTerm: term });
  }
}

const PropMapper = (
  {
    archivedEventFSObjects,
    archivedEventFSObjectsSorting,
    isFSObjectLoading,
    user,
    eventArchivedFSObjectSearchResults
  },
  { match }
) => {
  const eventMatch = matchPath(match.url, {
    path: Paths.EventDashTrash
  });

  return {
    teamId: eventMatch.params.teamId,
    eventId: eventMatch.params.eventId,
    items: archivedEventFSObjects,
    sorting: archivedEventFSObjectsSorting,
    isLoading: isFSObjectLoading,
    user: user,
    searchResults: eventArchivedFSObjectSearchResults
  };
};

export { PropMapper, Unconnected };

export default withRouter(
  connect(PropMapper, {
    showModal,
    getArchived: getArchivedFSObjects,
    onSortChange: setArchivedFSObjectSorting,
    restore: restoreFSObject,
    downloadDoc: downloadFSDoc,
    searchArchivedFSObjects,
    clearArchivedFSObjectsSearchResults
  })(Unconnected)
);

/**
 * Handle click of an archived event file system object
 *
 * @param {*} history
 * @param {*} downloadFSDoc
 * @param {*} teamId
 * @param {*} eventId
 * @param viewPath
 * @param {*} item
 * @param e
 */
export const itemClickHandler = (
  history,
  downloadFSDoc,
  teamId,
  eventId,
  viewPath,
  item,
  e
) => {
  e.stopPropagation();

  if (isDirectory(item)) {
    return;
  }

  const refObjectId = getFSRefObjectId(item);

  if (isDocFSObject(item)) {
    downloadFSDoc(teamId, eventId, refObjectId);
    return;
  }
};
